module.exports = __webpack_public_path__ + "img/icon-pdf.3e58df34.svg";